import React from "react"
import {useRoomSetup, useLocal} from "../AppContext"

export const ConditionsBudget = () => {
    const roomSetup = useRoomSetup()
    const local = useLocal()
    const budget = roomSetup.getBudget()

    return budget
        ? local.currency(budget)
        : local.__("offenes Preisfenster")
}
